module.exports = __webpack_public_path__ + "img/no-frills.dbca8370.png";